<!--
  创建时间：2024/10/30 下午5:54
  创建人：toyeh
  文件描述：FriendlyLink
-->

<template>
  <div class="friendly-link">
    <ul v-if="isCardItem" class="card-link-list">
      <li v-for="link in showListData" :key="link.id" class="card-link-item">
        <Link :to="link.url || ''" :title="link.name" class="flex-center">
          <img :src="link.image" :alt="link.name">
        </Link>
      </li>
    </ul>
    <ul v-else class="txt-link-list">
      <li v-for="link in showListData" :key="link.id" class="txt-link-item">
        <Link :to="link.url || ''" :title="link.name"> {{ link.name }}</Link>
      </li>
    </ul>
  </div>
</template>

<script>
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import { getConstantDic, LINK_TYPE, SELECT_OPTION_CONFIG } from "@/utils/constant";
import linkApi from "@/api/link";

export default {
  name: "FriendlyLink",
  components: { Link },
  props: {
  },
  data() {
    return {
      linkList: {
        link: [],
        link_zfbm: [],
        link_xgdw: []
      }
    };
  },
  // 监听属性 类似于data概念
  computed: {
    activeCode() {
      return this.$route.params.code
    },
    friendlyLinks() {
      return getConstantDic(LINK_TYPE)
    },
    showListData() {
      return this.linkList[this.activeCode] || []
    },
    isCardItem() {
      return this.activeCode === LINK_TYPE.LINK[SELECT_OPTION_CONFIG.CODE];
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getListData()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    getListData() {
      const linkCodes = this.friendlyLinks.map(item => item[SELECT_OPTION_CONFIG.CODE])
      Promise.all(linkCodes.map(type => {
        return linkApi
          .list({
            type
          })
      })).then(res => {
        res?.forEach(({ data }, i) => {
          this.linkList = { ...this.linkList, [linkCodes[i]]: (data || []).slice(0, 10) }
        })
      })
    }
  }
};
</script>

<style scoped lang="scss">
.friendly-link{
	.card-link-list{
		min-height: 200px;
		display: flex;
		flex-flow: row wrap;
		.card-link-item{
			height: 78px;
			width: 232px;
			border: 1px solid #eee;
			margin-bottom: 10px;
			margin-right: 10px;
			padding: 10px;
			a{
				width: 100%;
				height: 100%;
				font-size: 0;
				img{
					max-width: 100%;
					max-height: 100%;
					object-fit: contain;
				}
			}
			&:nth-of-type(3n) {
				margin-right: 0;
			}
			&:hover{
				border-color: $--color-primary;
				img{
					opacity: 0.8;
				}
			}
		}
	}
	.txt-link-list{
		min-height: 180px;
		display: flex;
		flex-flow: row wrap;
		padding: 20px 0;
		border: 1px solid #ddd;
		justify-content: flex-start;
		.txt-link-item{
			width: 220px;
			line-height: 40px;
			height: 40px;
			padding: 0 20px;
			a {
				color: #333;
				display: block;
				width: 100%;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				&:hover{
					color: $--color-primary;
				}
			}
		}
	}
}
</style>
